
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { SparepartsApi } from "./api";
import SparepartsGrid from "./SparepartsGrid";

interface SparepartsWidgetProps {
  id: string;
  header: string;
  machine?: String;
}

const SparepartsWidget = (props: SparepartsWidgetProps) => {
  const [spareparts, updateSpareparts] = useState(null);
  const [sparepartsLoading, updateLoadingSpareParts] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    updateSpareparts(null);
    if (globalParams.mainMachineSerialNo != null) {
      updateLoadingSpareParts(true);
      getSpareparts(globalParams.mainMachineSerialNo);
    }
  }, [globalParams.mainMachineSerialNo]);

  const getSpareparts = (m) => {
    let params: any = { machineSerial: m };
    SparepartsApi.getSpareparts(params)
      .then((response: any) => {
        updateSpareparts(response);
        updateLoadingSpareParts(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingSpareParts(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (sparepartsLoading) {
    return <Spinner text="spare parts" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <SparepartsGrid data={spareparts} />;
};

export default SparepartsWidget;
